
/**
 * TODO: Queda pendiente agregar a los otros dos formularios lo mismo que tiene RequestForm.
 * Asi mismo, debo validar si usaré el EstablishmentService.
 */
import Vue from 'vue';
import { mapGetters } from "vuex";
import RequestFormExterno from './RequestFormExterno.vue';
import RequestFormSolicitudAnuncios from "@/components/AnunciosExternos/Create/RequestFormSolicitudAnuncios.vue";
import RULES from "@/mixins/rules";
import router from '@/router';

export default Vue.extend(
  {
    name: "CreateAnuncioExterno",
    mixins: [RULES],
    components: {
      RequestFormSolicitudAnuncios,
      RequestFormExterno
    },
    directives: {},
    data(){
      return {
        currentStep: 1,
        totalSteps: 3,
        giro: "",
        idEstablecimiento: "",
        dialog: false,
        guardar: false,
        creado: false,
        actualizar: false,
        id_creado: 0,
        formData: {
          request: {},
        }
      };
    },
    mounted() {
      console.log(this.$route.params.idEstablecimiento);
      this.idEstablecimiento = this.$route.params.idEstablecimiento;
    },
    computed: {
      ...mapGetters({
        usuario: 'usuario', id: 'id', contribuyente: 'contribuyente', mini: 'sidebar'
      }),
    },
    watch: {},
    methods: {
      async submitForm(payload: any){
        console.log("form submited", payload);
        /*this.guardar = false;
        if (payload.success) {
          this.creado = true;
          this.id_creado = payload.location.id;
        }*/
      },
      async triggerGuardar() {
        await (this.$refs.requestForm as any).handleFormSubmit();
      },
      handleFormSubmitted(data: any) {
        this.submitData();
      },
      submitData() {
        router.back();
        //console.log('Enviar datos:', this.formData);
        //router.push({ name: 'index-anuncios', params: {idSolicitud: item.id, establecimiento: item.nombre_comercial}})
      },
    },
  }
)
